<template>
  <!--
    We use a light background color ('bg-light') to create a visual distinction
    from other sections.
  -->
  <section id="ou-sommes-nous" class="py-5 bg-light">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="display-5 fw-bold">Contact et Accès</h2>
        <p class="lead text-muted">Retrouvez-nous facilement et consultez nos horaires d'ouverture.</p>
      </div>

      <div class="row align-items-center g-4">
        <!-- Column 1: Google Maps -->
        <div class="col-lg-7">
          <div class="map-container shadow rounded overflow-hidden">
            <!--
              IMPORTANT: Replace this iframe with the one provided by Google Maps for your address.
            -->
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2894.493353597565!2d0.1039965154922616!3d43.21178617913878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a9c9a7e6b8f3a1%3A0x6e8f1b3f2e4c2b9a!2s3B%20Rue%20Georges%20N%C3%A9risson%2C%2065430%20Soues!5e0!3m2!1sfr!2sfr!4v1660838458933!5m2!1sfr!2sfr"
              width="100%"
              height="450"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>

        <!-- Column 2: Information (MODIFIED) -->
        <div class="col-lg-5">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4 text-center">
              <ul class="list-unstyled mb-0">
                <!-- Address -->
                <li class="d-inline-flex align-items-start mb-4">
                  <i class="bi bi-geo-alt-fill text-primary fs-3 me-3"></i>
                  <div class="text-start">
                    <h5 class="mb-1">Adresse</h5>
                    <span>3 bis rue Georges Nerisson<br>65430 Soues</span>
                  </div>
                </li>
                <!-- Phone -->
                <li class="d-inline-flex align-items-start mb-4">
                  <i class="bi bi-telephone-fill text-primary fs-3 me-3"></i>
                  <div class="text-start">
                    <h5 class="mb-1">Téléphone</h5>
                    <span>05.62.94.84.85</span>
                  </div>
                </li>
                <!-- Hours -->
                <li class="d-inline-flex align-items-start">
                  <i class="bi bi-clock-fill text-primary fs-3 me-3"></i>
                  <div class="text-start">
                    <h5 class="mb-1">Horaires</h5>
                    <span>Du Lundi au Vendredi<br>7h30 – 18h30</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// No JavaScript logic needed.
</script>

<style scoped>
.map-container {
  line-height: 0; /* Eliminates small white space under the iframe */
}
</style>
